import { render, staticRenderFns } from "./admin-product-item.vue?vue&type=template&id=1ec7ab3f&scoped=true&"
import script from "./admin-product-item.vue?vue&type=script&lang=js&"
export * from "./admin-product-item.vue?vue&type=script&lang=js&"
import style0 from "./admin-product-item.vue?vue&type=style&index=0&id=1ec7ab3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec7ab3f",
  null
  
)

export default component.exports